import React, { useState, useEffect } from 'react';
import { db, auth } from '../../firebase';
import { ref, onValue, update } from 'firebase/database';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaArrowLeft, FaFileAlt } from 'react-icons/fa';
import EngineerLayout from './EngineerLayout';

const EngineerEngineerDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        firstName: '',
        middleName: '',
        surname: '',
        whatsappNo: '',
        email: '',
        aadharNo: '',
        panNo: '',
        gstNo: '',
        dob: '',
        birthPlace: '',
        taluka: '',
        trade: '',
        technicalQualification: '',
        universityName: '',
        passingYear: '',
        businessLocation: '',
        bankName: '',
        address: '',
        bankAddress: ''
    });

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (!user) navigate('/login');
        });

        if (id) {
            const engineerRef = ref(db, `ekamwatapzp/EngineerRegistrations/${id}`);
            const unsubData = onValue(engineerRef, (snapshot) => {
                if (snapshot.exists()) {
                    setFormData(prev => ({ ...prev, ...snapshot.val() }));
                } else {
                    toast.error("Engineer data not found");
                    navigate('/engineer/engineers');
                }
                setLoading(false);
            });

            return () => {
                unsubscribe();
                unsubData();
            };
        }
    }, [id, navigate]);

    if (loading) {
        return (
            <EngineerLayout>
                <div className="min-h-screen flex items-center justify-center bg-gray-50/50">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#085e53]"></div>
                </div>
            </EngineerLayout>
        );
    }

    const DetailField = ({ label, value, fullWidth = false }) => (
        <div className={`space-y-1.5 ${fullWidth ? 'md:col-span-3' : ''}`}>
            <label className="text-[11px] font-bold text-gray-400 uppercase tracking-widest ml-1">{label}</label>
            <div className="bg-gray-50 border border-gray-100 rounded-xl px-5 py-3.5 text-sm font-bold text-gray-700 shadow-sm transition-all hover:border-gray-200">
                {value || '-'}
            </div>
        </div>
    );

    return (
        <EngineerLayout>
            <div className="p-6 md:p-8 bg-gray-50/30 min-h-screen">
                {/* Dark Header Card */}
                <div className="bg-[#1a1c23] rounded-3xl p-10 mb-8 shadow-2xl relative overflow-hidden group">
                    <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-32 -mt-32 blur-3xl transition-transform duration-1000 group-hover:scale-110"></div>
                    
                    <div className="relative flex flex-col md:flex-row justify-between items-center gap-6">
                        <div className="flex items-center gap-6">
                            <div className="w-16 h-16 bg-[#2d2f39] rounded-2xl flex items-center justify-center text-white border border-white/5 shadow-xl">
                                <FaFileAlt size={24} />
                            </div>
                            <div>
                                <h1 className="text-4xl font-bold text-white tracking-tight mb-2">अर्जाचा तपशील</h1>
                                <p className="text-gray-400 font-bold text-sm tracking-widest uppercase">
                                    अर्जदाराची संपूर्ण माहिती आणि कागदपत्रे
                                </p>
                            </div>
                        </div>
                        <button 
                            onClick={() => navigate(-1)}
                            className="bg-[#2d2f39] hover:bg-[#383a45] text-white px-8 py-3 rounded-xl text-sm font-bold tracking-widest transition-all hover:scale-105 active:scale-95 shadow-lg border border-white/5 flex items-center gap-3"
                        >
                            <FaArrowLeft size={14} /> मागे जा
                        </button>
                    </div>
                </div>

                <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
                    <div className="px-10 py-8 border-b border-gray-50 bg-white sticky top-0 z-10">
                        <div className="flex items-center gap-3">
                            <div className="h-5 w-1 bg-[#0ea5e9] rounded-full"></div>
                            <h2 className="text-lg font-bold text-gray-800 tracking-tight">वैयक्तिक आणि शैक्षणिक माहिती</h2>
                        </div>
                    </div>

                    <div className="p-10">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-8">
                            <DetailField 
                                label="Name Of Applicant" 
                                value={`${formData.firstName} ${formData.middleName} ${formData.surname}`} 
                            />
                            <DetailField label="Phone No." value={formData.whatsappNo} />
                            <DetailField label="Email Id" value={formData.email} />
                            
                            <DetailField label="Adhar Number" value={formData.aadharNo} />
                            <DetailField label="Pan Number" value={formData.panNo} />
                            <DetailField label="GST Number" value={formData.gstNo} />
                            
                            <DetailField label="Date Of Birth" value={formData.dob} />
                            <DetailField label="Place Of Birth" value={formData.birthPlace} />
                            <DetailField label="Taluka (तालुका)" value={formData.taluka} />
                            
                            <DetailField label="ट्रेड" value={formData.trade} />
                            <DetailField label="Technical Qualification" value={formData.technicalQualification} />
                            <DetailField label="Name Of Institute" value={formData.universityName} />
                            
                            <DetailField label="Name Of University" value={formData.universityName} />
                            <DetailField label="Passing Year" value={formData.passingYear} />
                            <DetailField label="Place Of Business" value={formData.businessLocation} />
                            
                            <DetailField label="Name Of Bankers" value={formData.bankName} />
                            <DetailField label="Present Address" value={formData.address} fullWidth />
                            <DetailField label="Bankers Address" value={formData.bankAddress} fullWidth />
                        </div>
                    </div>

                    <div className="p-10 bg-gray-50/50 border-t border-gray-50 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] font-bold text-gray-400 uppercase tracking-[0.2em]">
                        <div className="flex items-center gap-3">
                            <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full"></div>
                            अर्ज दस्तऐवज पडताळणीसाठी उपलब्ध
                        </div>
                        <span>ZP Sangli Application ID: {id.slice(-8).toUpperCase()}</span>
                    </div>
                </div>
            </div>
        </EngineerLayout>
    );
};

export default EngineerEngineerDetails;
